// 12.11.2025 Siegfried Steins — Exit-Overlay v14: Lean (nur Logik), Markup kommt aus Custom Liquid
(function(){
  // ---- Konfiguration (nur Keys/IDs; Inhalt/Buttons im Liquid) ----
  const KEY_HARD = "asst_seen_v14";          // dauerhaftes "gesehen" (localStorage)
  const KEY_SESS = "asst_seen_session_v14";  // bis zum nächsten Besuch (sessionStorage)
  const BOX_ID   = "assist-box";             // muss zur ID im Liquid passen

  const DEBUG = false;
  const log = (...a)=>{ if (DEBUG) console.log("[asst]", ...a); };

  function init(){
    const el = document.getElementById(BOX_ID);
    if (!el || el.dataset.asstBound === "1") return;
    el.dataset.asstBound = "1";
    log("init");

    // Falls Section unsichtbar war: sicherheitshalber direkt an <body> hängen
    if (el.parentElement !== document.body) document.body.appendChild(el);

    // Minimal: Overlay nicht von Theme-CSS killen lassen
    el.style.position = "fixed";
    el.style.inset    = "0";
    el.style.zIndex   = "2147483647";

    let open = false;

    // --------- Sichtbarkeits-Flags ----------
    const hardSeen = () => localStorage.getItem(KEY_HARD) === "1";
    const sessSeen = () => sessionStorage.getItem(KEY_SESS) === "1";
    const canShow  = () => !hardSeen() && !sessSeen();

    // --------- API ----------
    function show(){
      if (open) { log("show: already open"); return; }
      if (!canShow()) { log("show: blocked (seen)"); return; }
      el.classList.remove("asst--hidden");
      open = true;
      log("shown");
    }
    function hideSoft(){   // sofort wieder triggerbar
      if (!open) return;
      el.classList.add("asst--hidden");
      open = false;
      log("hidden SOFT");
    }
    function hideSession(){ // bis zum nächsten Besuch
      if (!open) return;
      el.classList.add("asst--hidden");
      open = false;
      sessionStorage.setItem(KEY_SESS, "1");
      log("hidden SESSION");
    }
    function hideHard(){    // dauerhaft
      if (!open) return;
      el.classList.add("asst--hidden");
      open = false;
      localStorage.setItem(KEY_HARD, "1");
      log("hidden HARD");
    }

    // --------- Button-/UI-Wiring (entspricht Option B im Liquid) ----------
    // X-Button = dauerhaft
    el.addEventListener("click", (e)=>{
      if (e.target.matches("[data-asst-close]")) { hideHard(); return; }
      if (e.target.hasAttribute("data-asst-backdrop")) { hideSoft(); return; } // Klick in den dunklen Bereich = Soft
      if (e.target.hasAttribute("data-asst-soft"))    { hideSoft(); return; }  // „Ausblenden“
      if (e.target.hasAttribute("data-asst-session")) { hideSession(); return; } // „bis zum nächsten Besuch“
      // Hinweis: WhatsApp-Link im Liquid bekommt kein spezielles Handling hier;
      // wenn du bei Klick dauerhaft schließen willst, gib dem Link data-asst-wa
    });

    // ESC = Soft
    document.addEventListener("keydown", (e)=>{ if (e.key === "Escape") hideSoft(); });

    // Optional: WA-Link als Hard-Dismiss (falls im Liquid data-asst-wa gesetzt ist)
    el.querySelector("[data-asst-wa]")?.addEventListener("click", ()=> {
      localStorage.setItem(KEY_HARD, "1");
      log("WA -> HARD seen");
    });

    // --------- Exit-Intent-Trigger (bewusst redundant, permanent aktiv) ----------
    const trigger = ()=> show();

    const onMouseOut   = (e)=>{
      const atEdge = (e.clientY<=0) || (e.clientX<=0) || (e.clientX>=innerWidth-1) || (e.clientY>=innerHeight-1);
      if (e.relatedTarget===null && atEdge) trigger();
    };
    const onMouseLeave = (e)=>{ if (e.relatedTarget===null) trigger(); };
    const onBlur       = ()=>  trigger();
    const onVis        = ()=>{ if (document.visibilityState==="hidden") trigger(); };

    let nearTopTimer = null;
    const onMove = (e)=>{
      if (e.clientY <= 6) {
        if (!nearTopTimer) nearTopTimer = setTimeout(()=>{ nearTopTimer=null; trigger(); }, 300);
      } else if (nearTopTimer) {
        clearTimeout(nearTopTimer); nearTopTimer = null;
      }
    };

    document.addEventListener("mouseout", onMouseOut);
    document.addEventListener("mouseleave", onMouseLeave);
    document.documentElement.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("blur", onBlur);
    document.addEventListener("visibilitychange", onVis);
    document.addEventListener("mousemove", onMove, { passive:true });

    // --------- Helpers für schnelle Tests ----------
    window.asstShow  = ()=> show();
    window.asstHide  = ()=> hideSoft();
    window.asstState = ()=> ({ open, hard: hardSeen(), session: sessSeen() });
  }

  // Init + Re-Init
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
  document.addEventListener("shopify:section:reorder", init);
  window.addEventListener("pageshow", init);
  document.addEventListener("page:load", init);
  document.addEventListener("swup:contentReplaced", init);
})();